import api from './client';
import type { TrackerCampaign } from './tracker-types';

export type CreateCampaignInput = Omit<Partial<TrackerCampaign>, 'id' | 'created_at'> & {
  name: string;
  domain_id: string;
  destination_type: 'redirect' | 'pwa' | 'offer_pool';
};

export const getCampaigns = () => api.get<TrackerCampaign[]>('/admin/tracker/campaigns');
export const getCampaign = (id: string) => api.get<TrackerCampaign>(`/admin/tracker/campaigns/${id}`);
export const createCampaign = (data: CreateCampaignInput) => api.post<TrackerCampaign>('/admin/tracker/campaigns', data);
export const updateCampaign = (id: string, data: Partial<TrackerCampaign>) => api.put<TrackerCampaign>(`/admin/tracker/campaigns/${id}`, data);
export const deleteCampaign = (id: string) => api.delete<{ message: string }>(`/admin/tracker/campaigns/${id}`);
export const duplicateCampaign = (id: string, name?: string) =>
  api.post<TrackerCampaign>(`/admin/tracker/campaigns/${id}/duplicate`, name ? { name } : {});
